import React, { useState } from "react";
import { Button, Form, Radio, Input, Tooltip } from "antd";
import { CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

interface GradeReportProps {
  onGradeSubmit: (values: any) => void;
  reportId?: string;
}

const Grade: React.FC<GradeReportProps> = ({ onGradeSubmit, reportId }) => {
  const [isGradeModalVisible, setIsGradeModalVisible] = useState(false);
  const [isGraded, setIsGraded] = useState(false);
  const [form] = Form.useForm();
  
  

  const handleGradeClick = () => {
    setIsGradeModalVisible(prev => !prev);
  };

  const handleGradeSubmit = (values: any) => {
    onGradeSubmit(values);
    setIsGradeModalVisible(false);
    setIsGraded(true);
    form.resetFields();
  };

  const gradingInfo = (
    <div style={{ maxWidth: '400px', padding: '8px 0' }}>
      <p style={{ margin: '0 0 8px 0', fontWeight: '600', color: 'white', fontSize: '13px' }}>Score 1: The reviewing radiologist agrees with the original report</p>
      <p style={{ margin: '0 0 12px 0', paddingLeft: '12px', fontSize: '12px', color: 'white' }}><strong>1A:</strong> Concur with interpretation</p>
      
      <p style={{ margin: '0 0 8px 0', fontWeight: '600', color: 'white', fontSize: '13px' }}>Score 2: Discrepancy in interpretation—not ordinarily expected to be made</p>
      <p style={{ margin: '0 0 4px 0', paddingLeft: '12px', fontSize: '12px', color: 'white' }}><strong>2A:</strong> Discrepancy that is unlikely to be clinically significant</p>
      <p style={{ margin: '0 0 12px 0', paddingLeft: '12px', fontSize: '12px', color: 'white' }}><strong>2B:</strong> Discrepancy that is likely to be clinically significant</p>
      
      <p style={{ margin: '0 0 8px 0', fontWeight: '600', color: 'white', fontSize: '13px' }}>Score 3: Discrepancy in interpretation—should be made most of the time</p>
      <p style={{ margin: '0 0 4px 0', paddingLeft: '12px', fontSize: '12px', color: 'white' }}><strong>3A:</strong> Discrepancy that is unlikely to be clinically significant</p>
      <p style={{ margin: '0 0 0 0', paddingLeft: '12px', fontSize: '12px', color: 'white' }}><strong>3B:</strong> Discrepancy that is likely to be clinically significant</p>
    </div>
  );

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        {isGraded ? (
          <GradeButton onClick={handleGradeClick} style={{ background: "#f6ffed", color: "#52c41a", borderColor: "#52c41a" }}>
            Graded <CheckCircleOutlined style={{ marginLeft: "8px" }} />
          </GradeButton>
        ) : (
          <GradeButton onClick={handleGradeClick}>
            Grade This Report
          </GradeButton>
        )}
      </div>

      {isGradeModalVisible && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 10px)",
            right: 0,
            width: "500px",
            background: "#fff",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            padding: "16px",
            zIndex: 1000,
            maxHeight: "90vh",
            overflowY: "auto"
          }}
        >
          {/* Caret */}
          <div style={{
            position: 'absolute',
            top: '-10px',
            right: '20px',
            width: 0,
            height: 0,
            borderLeft: '10px solid transparent',
            borderRight: '10px solid transparent',
            borderBottom: '10px solid white',
          }} />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <h3 style={{ margin: 0, fontSize: "16px", display: 'flex', alignItems: 'center', gap: '8px' }}>
              Grade Report
              <Tooltip title={gradingInfo}>
                <InfoCircleOutlined style={{ color: '#9370DB', cursor: 'pointer' }} />
              </Tooltip>
            </h3>
            <Button type="text" onClick={() => setIsGradeModalVisible(false)}>
              ×
            </Button>
          </div>
          <Form 
            form={form} 
            layout="vertical" 
            onFinish={handleGradeSubmit} 
            style={{display:'flex',flexDirection:'column',gap:'1rem'}}
          >
            <Form.Item
              name="Grade the report"
              label={<span>Grade the report</span>}
              rules={[
                {
                  required: true,
                  message: "Please select a grade option",
                },
              ]}
            >

              <Radio.Group
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.75rem",
                }}
              >
                <label style={{fontSize:'14px',color:'gray'}}>Score 1: The reviewing radiologist agrees with the original report</label>
                <Radio value="1A: Concur with interpretation">
                  1A: Concur with interpretation
                </Radio>
                <label style={{fontSize:'14px',color:'gray'}}>Score 2: Discrepancy in interpretation—not ordinarily expected to be made</label>
               
                <Radio value="2A: Discrepancy that is unlikely to be clinically significant">
                  2A: Discrepancy that is unlikely to be clinically significant
                </Radio>
                <Radio value="2B: Discrepancy that is likely to be clinically significant">
                  2B: Discrepancy that is likely to be clinically significant
                </Radio>
                <label style={{fontSize:'14px',color:'gray'}}>Score 3: Discrepancy in interpretation—should be made most of the time</label>
               
                <Radio value="3A: Discrepancy that is unlikely to be clinically significant">
                  
                  3A: Discrepancy that is unlikely to be clinically significant
                </Radio>
                <Radio value="3B: Discrepancy that is likely to be clinically significant">
                  3B: Discrepancy that is likely to be clinically significant
                </Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name="spellCheck"
              label={<span>Spell Check</span>}
              rules={[
                {
                  required: true,
                  message: "Please select a spell check option",
                },
              ]}
            >
              <Radio.Group>
                <Radio value="A">A</Radio>
                <Radio value="B">B</Radio>
                <Radio value="C">C</Radio>
                <Radio value="D">D</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item shouldUpdate>
              {({ getFieldValue }) => {
                const gradeSelected = getFieldValue("Grade the report");
                const spellCheckSelected = getFieldValue("spellCheck");
                const anyOneSelected = gradeSelected || spellCheckSelected;

                return (
                  <style>
                    {`
                      ${
                        anyOneSelected
                          ? `
                        .ant-radio-wrapper-checked {
                          color: #9370db;
                        }
                        .ant-radio-checked .ant-radio-inner {
                          border-color: #9370db;
                        }
                        .ant-radio-checked .ant-radio-inner:after {
                          background-color: #9370db;
                        }
                      `
                          : `
                        .ant-radio-wrapper-checked {
                          color: inherit;
                        }
                        .ant-radio-checked .ant-radio-inner {
                          border-color: #d9d9d9;
                        }
                        .ant-radio-checked .ant-radio-inner:after {
                          background-color: #d9d9d9;
                        }
                      `
                      }
                    `}
                  </style>
                );
              }}
            </Form.Item>

            <Form.Item
              name="comments"
              label={<span>Comments/Findings</span>}
              style={{ marginTop: '-6rem' }}
            >
              <Input.TextArea
                rows={3}
                placeholder="Enter your comments here..."
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, textAlign: 'center' }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  background: "#9370DB",
                  borderRadius: "2rem",
                  padding: '0 2rem'
                }}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
    </div>
  );
};

const GradeButton = styled(Button)`
  background: white;
  color: #9370db;
  border: 2px solid #9370db;
  border-radius: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  &:hover {
    background: white;
    color: #9370db;
    border-color: #9370db;
  }
`;



export default Grade; 